<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
        
        <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Saldos
            </b-card-header>
            <b-card-body>
                <div class="row">
                    <div class="col-md-6">
                        <label>Saldo de cuenta</label> 
                        <base-input disabled v-model="saldos.FormatedAmount"></base-input>
                    </div>
                    <div class="col-md-6">
                        <label>Saldo disponible para transferencia</label> 
                        <base-input disabled v-model="saldos.FormatedAvailableAmount"></base-input>
                    </div>
                </div>   
            </b-card-body>
        </b-card>  

         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Ingreso de datos
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Importe</label>                         
                        <vue-numeric currency="$" v-bind:precision="2" decimal-separator	="." thousand-separator	=" " v-model="model.Importe" class="form-control"></vue-numeric>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Descripción</label> 
                        <base-input v-model="model.Descripcion"></base-input>
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Banco</label>      
                        <b-form-select v-model="model.BancoID">
                            <option v-for="item in bancos" v-bind:key="item.EntityID" :value="item.EntityID">
                                {{item.CBU}}
                            </option>
                        </b-form-select>
                    </div>
                </div>   
                <div class="row form-group" >
                    <div class="col-md-12">
                        <goback-button @click="volver"></goback-button>
                        <save-button @click="guardarTransferencia"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card>       
    </div>
</template>

<style>
</style>

<script>

    // ******************** Select ********************//
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    // ******************** Select ********************//

    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    import JsonCSV from 'vue-json-csv' 
    Vue.component('downloadCsv', JsonCSV)
    
    export default{
        components: { },
        data(){
            return{
                saldos: {FormatedAmount: '', FormatedAvailableAmount: ''},
                model : {Importe: 0, Descripcion: '', BancoID: null},
                bancos: [],
            }
        },
        methods: {
            volver(){
                this.$router.push('solicitudes')
            },
            cargarSaldos(context){
                axiosHelpers.axiosGet('Supplier/AddSupplierTransferGet', {}, context, function(data){ 
                    context.saldos = data.ResponseVM;
                });
            },
            guardarTransferencia(){
                if(this.model.Importe <= 0){
                    notificationHelpers.showWarning('Alerta', 'El importe debe ser superior a 0', this);
                    return;
                }
                if(this.model.Descripcion == ''){
                    notificationHelpers.showWarning('Alerta', 'Debe ingresar una descripción', this);
                    return;
                }
                if(this.model.BancoID == null){
                    notificationHelpers.showWarning('Alerta', 'Debe seleccionar un banco', this);
                    return;
                }

                let req = { Amount: this.model.Importe, Description: this.model.Descripcion, SupplierBankAccountID: this.model.BancoID};

                let context = this
                axiosHelpers.axiosPost('Supplier/AddSupplierTransfer', req, this, function(data){ 
                    if(data.ResponseVM.Result){
                        notificationHelpers.showSuccess('Exito', 'Se agregó la solicitud de transferencia correctamente', context);
                        context.model.Importe = 0;
                        context.model.Descripcion = '';
                        context.model.BancoID = null;

                        context.cargarSaldos(context);
                    }
                });
            }
        },
        beforeMount: function(){
            let context = this;
            this.cargarSaldos(this);

             axiosHelpers.axiosPost('Supplier/GetSupplierBankAccountList', {}, this, function(data){ 
                    context.bancos = data.ResponseVM;
                });
        }
    }
</script>